<template>
  <div>
    <v-row>
      <v-col>
        <v-text-field
            v-if="notationType === 'clause'"
            v-model="internalValue.title"
            label="名称"
            :rules="[v => !!v || '名称を入力してください']"
            @change="emitChange"
            @input="emitChange"
            :readonly="readonly"
            :autofocus="!readonly">
        </v-text-field>
        <v-combobox
            v-if="notationType === 'parameter'"
            v-model="internalValue.title"
            label="名称"
            :items="parameterTitleHints"
            :rules="[v => !!v || '名称を入力してください']"
            @change="emitChangeAndClearContents"
            @input="emitChangeAndClearContents"
            :readonly="readonly"
            :menu-props="{'contentClass': 'parameter-hints'}"
            :return-object="false"
            :messages="parameterTitleHint"
            :autofocus="!readonly">
          <template #item="{item, on, attrs}">
            <v-list-item v-bind="attrs" v-on="on" tag="dl">
              <dt>{{ item.text }}</dt>
              <dd>{{ item.hint }}</dd>
            </v-list-item>
          </template>
        </v-combobox>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
            v-if="notationType === 'clause' || parameterContentHints === null"
            v-model="internalValue.content"
            label="内容"
            messages="複数行入力可"
            :rules="[v => !!v || '内容を入力してください']"
            @change="emitChange"
            @input="emitChange"
            :readonly="readonly"
            rows="1"
            auto-grow>
        </v-textarea>
        <v-combobox
            v-else
            v-model="internalValue.content"
            label="内容"
            :items="parameterContentHints"
            :rules="[v => !!v || '内容を入力してください']"
            @change="emitChange"
            @input="emitChange"
            :readonly="readonly"
            :menu-props="{'contentClass': 'parameter-hints'}"
            :messages="parameterContentHint"
            :return-object="false">
          <template #item="{item, on, attrs}">
            <v-list-item v-bind="attrs" v-on="on" tag="dl">
              <dt>{{ item.text }}</dt>
              <dd>{{ item.hint }}</dd>
            </v-list-item>
          </template>
        </v-combobox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {CONTRACT_PROFILE_PARAMETER_HINTS} from "@/constants";

export default {
  name: "ContractProfileForm",
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    notationType: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    value: Object
  },
  data() {
    return {
      internalValue: {
        title: '',
        content: '',
      }
    };
  },
  computed: {
    parameterTitleHints() {
      return CONTRACT_PROFILE_PARAMETER_HINTS.map(h => ({
        text: h.title,
        value: h.title,
        hint: h.hint,
      }));
    },
    parameterTitleSelection() {
      return CONTRACT_PROFILE_PARAMETER_HINTS.find(h => h.title === this.internalValue.title);
    },
    parameterTitleHint() {
      return this.parameterTitleSelection?.hint ?? '';
    },
    parameterContentHints() {
      return this.parameterTitleSelection?.contents?.map(c => ({
        text: c.value,
        value: c.value,
        hint: c.hint
      })) ?? null;
    },
    parameterContentHint() {
      return this.parameterTitleSelection?.contents?.find(c => c.value === this.internalValue.content)?.hint ?? '';
    }
  },
  methods: {
    emitChange() {
      this.$emit('change', this.internalValue);
    },
    emitChangeAndClearContents() {
      this.internalValue.content = '';
      this.emitChange();
    }
  },
  watch: {
    value: {
      handler(value) {
        this.internalValue = {
          ...value,
          title: value?.title || '',
          content: value?.content || '',
        };
      },
      immediate: true
    },
  }
}
</script>

<style lang="scss">
.parameter-hints {
  .v-list-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-height: auto;
    padding: 5px 16px;

    dd {
      font-size: 80%;
      color: #666;
    }
  }
}
</style>
